import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const RevenueitemListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [revenueitems, setRevenueitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [revenueSources, setRevenueSources] = useState([]);
  const [revenueStatuses, setRevenueStatuses] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/revenue-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setRevenueitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
        
    }, Math.random() * 1000 + 250);
    apiCall('get', '/api/v2/dictionary/revenue-source')
      .then(response => {
        const d = response.data?.data || response.data;
        const list = Array.isArray(d) ? d : (d?.data || []);
        setRevenueSources(list || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
      apiCall('get', '/api/v2/dictionary/revenue-status')
      .then(response => {
        const d = response.data?.data || response.data;
        const list = Array.isArray(d) ? d : (d?.data || []);
        setRevenueStatuses(list || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  if(entity === 'revenue-item') {
                    history.push('/finance/revenue-item/read/' + rowData.id)
                  }
                }}/>
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderTmpList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={revenueitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="name" header={t('columnName')} sortable filter></Column>
        <Column field="source" header={t('columnSource')} sortable filter
        body={(rowData) => {
          const key = rowData.source;
          const found = revenueSources?.find(x => x.key === key);
          return <>{found?.value || key || ''}</>;
        }}></Column>
        <Column field="status" header={t('columnStatus2')} sortable filter
        body={(rowData) => {
          const key = rowData.status;
          const found = revenueStatuses?.find(x => x.key === key);
          return <>{found?.value || key || ''}</>;
        }}></Column>
        <Column field="name" header={t('columnName')} sortable filter></Column>
        <Column field="amount" header={t('columnAmount')} sortable filter filterMatchMode="between"
          body={(rowData) => {
            const amount = rowData?.amount;
            const currency = rowData?.currency || 'HUF';
            const num = Number(amount);
            if (amount === null || amount === undefined || Number.isNaN(num)) return <></>;
            return <>{window.App.currencyFormatter(currency, num)}</>;
          }}></Column>




        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(RevenueitemListComponent);
